import config from "./config";
var axios = config();

export default {
  getCurrentTimePeriod() {
    return axios.get("/api/TimePeriods/GetCurrentTimePeriod");
  },

  getFiscalYearTimePeriod() {
    return axios.get("/api/TimePeriods/GetFiscalYearTimePeriod");
  },

  getNextTimePeriod() {
    return axios.get("/api/TimePeriods/GetNextTimePeriod");
  },

  getYearTerms(date) {
    return axios.get("/api/TimePeriods/GetYearTerms", {
      params: { date: date }
    });
  },

  getTimePeriods() {
    return axios.get("/api/TimePeriods/GetTimePeriods");
  },

  getTimePeriodById(id) {
    return axios.get("/api/TimePeriods/GetTimePeriodById/" + id);
  }
};
